import $ from 'jquery';
import _ from 'underscore';

// import Modal from './Modal';

export default class Gallery {

  constructor (options) {
    if (options.elements.length < 1) return null

    this.startIndex = 0;
    this.currentIndex = 0;
    this.data = this.initData(options.elements);
    this.el = this.getGalleryModal();
    this.previousImageEl = this.el.querySelector('.c-gallery__previous');
    this.currentImageEl = this.el.querySelector('.c-gallery__current');
    this.nextImageEl = this.el.querySelector('.c-gallery__next');

    this.initGalleryModal();
    this.listen();

    // console.dir(this);
  }

  listen () {
    $('[data-gallery-open]').on('click', (e) => {
      e.preventDefault();
      let clickedIndex = parseInt(e.target.getAttribute('data-gallery-index')) - 1;
      this.goTo(clickedIndex);
      this.open();
    })

    $('[data-gallery-close]').on('click', (e) => {
      e.preventDefault();
      this.close();
    })

    $('[data-gallery-prev]').on('click', (e) => {
      e.preventDefault();
      this.goPrevious();
    })

    $('[data-gallery-next]').on('click', (e) => {
      e.preventDefault();
      this.goNext();
    })

    $('.c-gallery__container').on('click', (e) => {
      e.stopPropagation();
      if (e.target.className === 'c-gallery__container') {
        this.close();
      }
    })

    document.addEventListener('keydown', (e) => {
      switch(e.key) {
        case 'Escape': {
          this.close();
          break;
        }
        case 'ArrowLeft': {
          this.goPrevious();
          break;
        }
        case 'ArrowRight': {
          this.goNext();
          break;
        }
        default: return;
      }
    })
  }

  open () {
    $(this.el).fadeIn();
    $(document.body).addClass('js-gallery-open');
  }

  close () {
    $(this.el).fadeOut();
    $(document.body).removeClass('js-gallery-open');
  }

  initData (elements) {
    // console.dir(elements);
    let data = []

    _.map(elements, (el) => {
      data.push({
        src: (el.querySelector('[data-gallery-open]')) ? el.querySelector('[data-gallery-open]').getAttribute('data-gallery-src') : '',
        info: (el.querySelector('[data-gallery-info]')) ? el.querySelector('[data-gallery-info]').innerHTML : '',
        architect: (el.querySelector('[data-gallery-architect]')) ? el.querySelector('[data-gallery-architect]').innerHTML : '',
        link: (el.querySelector('[data-gallery-link]')) ? el.querySelector('[data-gallery-link]').href : ''
      })
    })

    return data;
  }

  initGalleryModal () {
    document.body.appendChild(this.el);
  }

  getGalleryModal () {
    let gallery = document.createElement('div');
    gallery.classList.add('c-gallery');
    gallery.innerHTML = this.renderGalleryTemplate();
    return gallery;
  }

  goTo (index) {
    this.currentIndex = index;
    this.renderTemplate(index);
  }

  goPrevious () {
    // console.dir(this.currentIndex);
    const index = this.currentIndex - 1;
    if (index >= 0) {
      this.goTo(index);
    }
  }

  goNext () {
    // console.dir(this.currentIndex);
    const index = this.currentIndex + 1;
    if (index <= this.data.length - 1) {
      this.goTo(index);
    }
  }

  renderTemplate(index) {
    this.previousImageEl.innerHTML = this.renderImageTemplate(this.data[index - 1])
    this.currentImageEl.innerHTML = this.renderImageTemplate(this.data[index])
    this.nextImageEl.innerHTML = this.renderImageTemplate(this.data[index + 1])
  }

  renderImageTemplate (data) {
    let architectString = '';

    if (data) {
      if (data.architect) {
        architectString = `<strong>Architect</strong><br />${data.architect}`;
      }

      // return `
      // <div class="c-gallery__header">
      //   <div class="c-gallery__info">${data.info}</div>
      //   <div class="c-gallery__architect">${architectString}</div>
      //   <a href="${data.link}" class="c-gallery__link button white large">View Showhome</a>
      // </div>
      // <div class="c-gallery__image"><img src="${data.src}" alt=""></div>
      // `

      return `
        <div class="c-gallery__header">
          <div class="c-gallery__info">${data.info}</div>
          <div class="c-gallery__architect">${architectString}</div>
        </div>
        <div class="c-gallery__image">
          <img src="${data.src}" alt="">
        </div>
        <a href="${data.link}" class="c-gallery__link button large">View Showhome</a>
      `
    }
    return '';
  }

  renderGalleryTemplate () {
    return `
    <div class="c-gallery__container">
      <div class="c-gallery__view">
        <div class="c-gallery__previous"></div>
        <div class="c-gallery__current"></div>
        <div class="c-gallery__next"></div>

        <div class="c-gallery__controls">
          <div class="c-gallery__control-prev" data-gallery-prev></div>
          <div class="c-gallery__control-next" data-gallery-next></div>
        </div>

        <div class="c-gallery__control-close" data-gallery-close></div>
      </div>
    </div>
    `
  }

}
